import { render } from "./WeeklyResults.vue?vue&type=template&id=0c630621&scoped=true"
import script from "./WeeklyResults.vue?vue&type=script&lang=js"
export * from "./WeeklyResults.vue?vue&type=script&lang=js"

import "./WeeklyResults.vue?vue&type=style&index=0&id=0c630621&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0c630621"

export default script